export enum EShowBanner {
  MAIN_PROMO = "MainPromo",
  SCHOOL = "School",
}
